import { useMutation } from "@apollo/client";
import React, { useRef, useState } from "react";
import { Button, Input } from "reactstrap";
import {
  CREATE_OR_UPDATE_SUPPORTER_PUBLISHED_INFO,
  UPDATE_REGULATION,
} from "../../../../queries";
import * as Ionicons from "react-icons/io";
import { Spinner } from "reactstrap";

const EditLink = ({ id, refetch, link }) => {
  const [test, setTest] = useState(link);

  const [editSupporterPublishedInfo, { data, loading }] = useMutation(
    CREATE_OR_UPDATE_SUPPORTER_PUBLISHED_INFO,
    {
      onCompleted() {
        refetch();
      },
    }
  );

  const editLink = async () => {
    await editSupporterPublishedInfo({
      variables: {
        publishedInformationId: id,
        referenceUrl: test,
      },
    });
  };

  return (
    <>
      <div
        className="ema__flex ema__align_items_center mt-3 mb-2"
        style={{ justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <div className="mb-1" style={{ width: "100%" }}>
          <Input
            placeholder="リンク"
            value={test}
            style={{ marginBottom: 0 }}
            onChange={(e) => {
              setTest(e.target.value);
            }}
          />
        </div>
        <Button
          size="lg"
          className="ema__btn__gray mb-1"
          onClick={() => editLink()}
        >
          {loading ? <Spinner size="sm"></Spinner> : "リンク更新"}
        </Button>
      </div>
    </>
  );
};

export default EditLink;
